import { render, staticRenderFns } from "./LedgersCollection.vue?vue&type=template&id=29e42ee2&"
import script from "./LedgersCollection.vue?vue&type=script&lang=js&"
export * from "./LedgersCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports